import { Injectable } from '@angular/core';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { HttpRequestDecorator } from '../../core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../../core/triggerbee/triggerbee-api.enum';
import { Observable } from 'rxjs';
import { ResponseStatistics } from '../../campaign/response-lists/response-lists.component';

@Injectable({
  providedIn: 'root',
})
export class ResponseTableService {
  private readonly logger: Logger;
  constructor(
    loggerFactory: LoggerFactory,
    private http: HttpRequestDecorator,
  ) {
    this.logger = loggerFactory.get('ResponseTableService');
  }

  private getResourceBase() {
    return this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/response-list-statistics`;
  }

  public getResponseStatistics(responseListId: string): Observable<any[]> {
    const url = `${this.getResourceBase()}/${responseListId}`;
    return this.http.get(url);
  }

  public getResponsesOverTime(responseListId: string, daysFromNow: number): Observable<ResponseStatistics> {
    const url = `${this.getResourceBase()}/responses-over-time/${responseListId}/${daysFromNow}`;
    return this.http.get(url);
  }
}

export interface StringValidator {
  data: DataRow[];
  columns: string[];
}

export interface DataRow {
  [key: string]: string;
}
